require("./common");
require("./bootstrap");
require("./inputmask");
require("./chartisan");
require("./alpine");
require("./pulltorefresh");
window.addEventListener("DOMContentLoaded", function () {
    $(function () {
        $('[data-toggle="tooltip"]').tooltip();
    });

    Livewire.hook("message.processed", (message, component) => {
        $(function () {
            $('[data-toggle="tooltip"]').tooltip();
        });
    });
    PullToRefresh.init({
        mainElement: "body",
        onRefresh() {
            window.location.reload();
        },
    });
});
